import { default as agent_45callbackgysKUIOyUNMeta } from "/app/pages/agent-callback.vue?macro=true";
import { default as indexZFWLsderreMeta } from "/app/pages/agent/my-refers/[refer_id]/index.vue?macro=true";
import { default as contractFMNhCZzMDeMeta } from "/app/pages/agent/my-refers/[refer_id]/management/contract.vue?macro=true";
import { default as index0Sub948tdpMeta } from "/app/pages/agent/my-refers/[refer_id]/management/index.vue?macro=true";
import { default as indexW4uot0Oz7qMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/cancel-contract/index.vue?macro=true";
import { default as indexw8RwCkrkZ2Meta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/index.vue?macro=true";
import { default as editdHOvycNQTaMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/make-appointment/edit.vue?macro=true";
import { default as indexO44yc4VUiTMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/make-appointment/index.vue?macro=true";
import { default as indexVsMu62DKlqMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/sale-contract/index.vue?macro=true";
import { default as edit_45appointment2TOiY3yRqwMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/upload-sale-contract/edit-appointment.vue?macro=true";
import { default as indexQwVjwKPwjSMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/upload-sale-contract/index.vue?macro=true";
import { default as indexq09DNH8YthMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/index.vue?macro=true";
import { default as historyvHwGoxAfk3Meta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/interest/history.vue?macro=true";
import { default as reportaDnqU6RPUyMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/interest/report.vue?macro=true";
import { default as historyww7lQuzRJFMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/monthly/history.vue?macro=true";
import { default as reporttradnWpJJrMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/monthly/report.vue?macro=true";
import { default as historyPxrXoA3m0UMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/visit/history.vue?macro=true";
import { default as reporta3sslVr6GBMeta } from "/app/pages/agent/my-refers/[refer_id]/management/sale-report/visit/report.vue?macro=true";
import { default as bank_45accountUtYoWtkYIUMeta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/bank-account.vue?macro=true";
import { default as edit_45updateyPmrmX5NriMeta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/edit-update.vue?macro=true";
import { default as edit_45uploadCESgQSobpgMeta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/edit-upload.vue?macro=true";
import { default as indexiiZ81IV4TJMeta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/index.vue?macro=true";
import { default as update5zAgt96SZeMeta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/update.vue?macro=true";
import { default as uploaddMym0TQx82Meta } from "/app/pages/agent/my-refers/[refer_id]/management/transference/upload.vue?macro=true";
import { default as indexR2oiAtKAJgMeta } from "/app/pages/agent/my-refers/[refer_id]/management/update-marketing/index.vue?macro=true";
import { default as marketing_45offline_45dailymEalhjL1VKMeta } from "/app/pages/agent/my-refers/[refer_id]/management/update-marketing/marketing-offline-daily.vue?macro=true";
import { default as marketing_45online_45dailyorx81cCaRDMeta } from "/app/pages/agent/my-refers/[refer_id]/management/update-marketing/marketing-online-daily.vue?macro=true";
import { default as upload_45contractP1zry47gpKMeta } from "/app/pages/agent/my-refers/[refer_id]/management/upload-contract.vue?macro=true";
import { default as reviewjyNhAuKz8UMeta } from "/app/pages/agent/my-refers/[refer_id]/review.vue?macro=true";
import { default as indexvQPAra3yGhMeta } from "/app/pages/agent/my-refers/index.vue?macro=true";
import { default as _91refer_id_93q0joIgXAkYMeta } from "/app/pages/agent/refers/[refer_id].vue?macro=true";
import { default as indexguqWiOI0TFMeta } from "/app/pages/agent/refers/index.vue?macro=true";
import { default as loginikXFF2hTKwMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as forget_45passwordEVWK44q6hlMeta } from "/app/pages/forget-password.vue?macro=true";
import { default as healthzgi5jXRlOnQMeta } from "/app/pages/healthz.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as listing_45insight_45backupxMNucnPezbMeta } from "/app/pages/listing-insight-backup.vue?macro=true";
import { default as listing_45insightXejzTz1ENLMeta } from "/app/pages/listing-insight.vue?macro=true";
import { default as nayoo_45callbacksr2mrYCOi3Meta } from "/app/pages/nayoo-callback.vue?macro=true";
import { default as indexGkDmAZq53wMeta } from "/app/pages/property-comparison/index.vue?macro=true";
import { default as insightIKNKOwCMfdMeta } from "/app/pages/property-comparison/insight.vue?macro=true";
import { default as resultsQg7MNNza8Meta } from "/app/pages/property-comparison/result.vue?macro=true";
import { default as property_45owner_45callbackRuNEbQxaVwMeta } from "/app/pages/property-owner-callback.vue?macro=true";
import { default as indexslGKw28EnlMeta } from "/app/pages/property-owner/index.vue?macro=true";
import { default as _91ordinal_93vvQiwsppcqMeta } from "/app/pages/property-owner/refer/[refer_id]/report-marketing/[ordinal].vue?macro=true";
import { default as indexzQOQlsRptWMeta } from "/app/pages/property-owner/refer/[refer_id]/report-marketing/index.vue?macro=true";
import { default as reviewtHpNp9vYxXMeta } from "/app/pages/property-owner/refer/[refer_id]/review.vue?macro=true";
import { default as indexWbETje4xSYMeta } from "/app/pages/property-owner/refer/[refer_id]/sale-agreement/index.vue?macro=true";
import { default as indexGhND8d1eWeMeta } from "/app/pages/property-owner/refer/[refer_id]/sale-report/interest/index.vue?macro=true";
import { default as index7FfcpiSYPjMeta } from "/app/pages/property-owner/refer/[refer_id]/sale-report/monthly/index.vue?macro=true";
import { default as indexlG5i6bQg10Meta } from "/app/pages/property-owner/refer/[refer_id]/sale-report/visit/index.vue?macro=true";
import { default as show_45confirmLJxnmxy7VfMeta } from "/app/pages/property-owner/refer/[refer_id]/show-confirm.vue?macro=true";
import { default as show_45have_45agentpAjsHXz70TMeta } from "/app/pages/property-owner/refer/[refer_id]/show-have-agent.vue?macro=true";
import { default as indexcTyFldMbfbMeta } from "/app/pages/property-owner/refer/[refer_id]/transference/index.vue?macro=true";
import { default as registerAnpuNsk5IFMeta } from "/app/pages/property-owner/register.vue?macro=true";
import { default as social_45callbackcznafy6RZnMeta } from "/app/pages/social-callback.vue?macro=true";
export default [
  {
    name: agent_45callbackgysKUIOyUNMeta?.name ?? "agent-callback",
    path: agent_45callbackgysKUIOyUNMeta?.path ?? "/agent-callback",
    meta: agent_45callbackgysKUIOyUNMeta || {},
    alias: agent_45callbackgysKUIOyUNMeta?.alias || [],
    redirect: agent_45callbackgysKUIOyUNMeta?.redirect || undefined,
    component: () => import("/app/pages/agent-callback.vue").then(m => m.default || m)
  },
  {
    name: indexZFWLsderreMeta?.name ?? "agent-my-refers-refer_id",
    path: indexZFWLsderreMeta?.path ?? "/agent/my-refers/:refer_id()",
    meta: indexZFWLsderreMeta || {},
    alias: indexZFWLsderreMeta?.alias || [],
    redirect: indexZFWLsderreMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/index.vue").then(m => m.default || m)
  },
  {
    name: contractFMNhCZzMDeMeta?.name ?? "agent-my-refers-refer_id-management-contract",
    path: contractFMNhCZzMDeMeta?.path ?? "/agent/my-refers/:refer_id()/management/contract",
    meta: contractFMNhCZzMDeMeta || {},
    alias: contractFMNhCZzMDeMeta?.alias || [],
    redirect: contractFMNhCZzMDeMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/contract.vue").then(m => m.default || m)
  },
  {
    name: index0Sub948tdpMeta?.name ?? "agent-my-refers-refer_id-management",
    path: index0Sub948tdpMeta?.path ?? "/agent/my-refers/:refer_id()/management",
    meta: index0Sub948tdpMeta || {},
    alias: index0Sub948tdpMeta?.alias || [],
    redirect: index0Sub948tdpMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/index.vue").then(m => m.default || m)
  },
  {
    name: indexW4uot0Oz7qMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-cancel-contract",
    path: indexW4uot0Oz7qMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/cancel-contract",
    meta: indexW4uot0Oz7qMeta || {},
    alias: indexW4uot0Oz7qMeta?.alias || [],
    redirect: indexW4uot0Oz7qMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/cancel-contract/index.vue").then(m => m.default || m)
  },
  {
    name: indexw8RwCkrkZ2Meta?.name ?? "agent-my-refers-refer_id-management-sale-agreement",
    path: indexw8RwCkrkZ2Meta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement",
    meta: indexw8RwCkrkZ2Meta || {},
    alias: indexw8RwCkrkZ2Meta?.alias || [],
    redirect: indexw8RwCkrkZ2Meta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/index.vue").then(m => m.default || m)
  },
  {
    name: editdHOvycNQTaMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-make-appointment-edit",
    path: editdHOvycNQTaMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/make-appointment/edit",
    meta: editdHOvycNQTaMeta || {},
    alias: editdHOvycNQTaMeta?.alias || [],
    redirect: editdHOvycNQTaMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/make-appointment/edit.vue").then(m => m.default || m)
  },
  {
    name: indexO44yc4VUiTMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-make-appointment",
    path: indexO44yc4VUiTMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/make-appointment",
    meta: indexO44yc4VUiTMeta || {},
    alias: indexO44yc4VUiTMeta?.alias || [],
    redirect: indexO44yc4VUiTMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/make-appointment/index.vue").then(m => m.default || m)
  },
  {
    name: indexVsMu62DKlqMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-sale-contract",
    path: indexVsMu62DKlqMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/sale-contract",
    meta: indexVsMu62DKlqMeta || {},
    alias: indexVsMu62DKlqMeta?.alias || [],
    redirect: indexVsMu62DKlqMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/sale-contract/index.vue").then(m => m.default || m)
  },
  {
    name: edit_45appointment2TOiY3yRqwMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-upload-sale-contract-edit-appointment",
    path: edit_45appointment2TOiY3yRqwMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/upload-sale-contract/edit-appointment",
    meta: edit_45appointment2TOiY3yRqwMeta || {},
    alias: edit_45appointment2TOiY3yRqwMeta?.alias || [],
    redirect: edit_45appointment2TOiY3yRqwMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/upload-sale-contract/edit-appointment.vue").then(m => m.default || m)
  },
  {
    name: indexQwVjwKPwjSMeta?.name ?? "agent-my-refers-refer_id-management-sale-agreement-upload-sale-contract",
    path: indexQwVjwKPwjSMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-agreement/upload-sale-contract",
    meta: indexQwVjwKPwjSMeta || {},
    alias: indexQwVjwKPwjSMeta?.alias || [],
    redirect: indexQwVjwKPwjSMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-agreement/upload-sale-contract/index.vue").then(m => m.default || m)
  },
  {
    name: indexq09DNH8YthMeta?.name ?? "agent-my-refers-refer_id-management-sale-report",
    path: indexq09DNH8YthMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report",
    meta: indexq09DNH8YthMeta || {},
    alias: indexq09DNH8YthMeta?.alias || [],
    redirect: indexq09DNH8YthMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/index.vue").then(m => m.default || m)
  },
  {
    name: historyvHwGoxAfk3Meta?.name ?? "agent-my-refers-refer_id-management-sale-report-interest-history",
    path: historyvHwGoxAfk3Meta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/interest/history",
    meta: historyvHwGoxAfk3Meta || {},
    alias: historyvHwGoxAfk3Meta?.alias || [],
    redirect: historyvHwGoxAfk3Meta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/interest/history.vue").then(m => m.default || m)
  },
  {
    name: reportaDnqU6RPUyMeta?.name ?? "agent-my-refers-refer_id-management-sale-report-interest-report",
    path: reportaDnqU6RPUyMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/interest/report",
    meta: reportaDnqU6RPUyMeta || {},
    alias: reportaDnqU6RPUyMeta?.alias || [],
    redirect: reportaDnqU6RPUyMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/interest/report.vue").then(m => m.default || m)
  },
  {
    name: historyww7lQuzRJFMeta?.name ?? "agent-my-refers-refer_id-management-sale-report-monthly-history",
    path: historyww7lQuzRJFMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/monthly/history",
    meta: historyww7lQuzRJFMeta || {},
    alias: historyww7lQuzRJFMeta?.alias || [],
    redirect: historyww7lQuzRJFMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/monthly/history.vue").then(m => m.default || m)
  },
  {
    name: reporttradnWpJJrMeta?.name ?? "agent-my-refers-refer_id-management-sale-report-monthly-report",
    path: reporttradnWpJJrMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/monthly/report",
    meta: reporttradnWpJJrMeta || {},
    alias: reporttradnWpJJrMeta?.alias || [],
    redirect: reporttradnWpJJrMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/monthly/report.vue").then(m => m.default || m)
  },
  {
    name: historyPxrXoA3m0UMeta?.name ?? "agent-my-refers-refer_id-management-sale-report-visit-history",
    path: historyPxrXoA3m0UMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/visit/history",
    meta: historyPxrXoA3m0UMeta || {},
    alias: historyPxrXoA3m0UMeta?.alias || [],
    redirect: historyPxrXoA3m0UMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/visit/history.vue").then(m => m.default || m)
  },
  {
    name: reporta3sslVr6GBMeta?.name ?? "agent-my-refers-refer_id-management-sale-report-visit-report",
    path: reporta3sslVr6GBMeta?.path ?? "/agent/my-refers/:refer_id()/management/sale-report/visit/report",
    meta: reporta3sslVr6GBMeta || {},
    alias: reporta3sslVr6GBMeta?.alias || [],
    redirect: reporta3sslVr6GBMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/sale-report/visit/report.vue").then(m => m.default || m)
  },
  {
    name: bank_45accountUtYoWtkYIUMeta?.name ?? "agent-my-refers-refer_id-management-transference-bank-account",
    path: bank_45accountUtYoWtkYIUMeta?.path ?? "/agent/my-refers/:refer_id()/management/transference/bank-account",
    meta: bank_45accountUtYoWtkYIUMeta || {},
    alias: bank_45accountUtYoWtkYIUMeta?.alias || [],
    redirect: bank_45accountUtYoWtkYIUMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/bank-account.vue").then(m => m.default || m)
  },
  {
    name: edit_45updateyPmrmX5NriMeta?.name ?? "agent-my-refers-refer_id-management-transference-edit-update",
    path: edit_45updateyPmrmX5NriMeta?.path ?? "/agent/my-refers/:refer_id()/management/transference/edit-update",
    meta: edit_45updateyPmrmX5NriMeta || {},
    alias: edit_45updateyPmrmX5NriMeta?.alias || [],
    redirect: edit_45updateyPmrmX5NriMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/edit-update.vue").then(m => m.default || m)
  },
  {
    name: edit_45uploadCESgQSobpgMeta?.name ?? "agent-my-refers-refer_id-management-transference-edit-upload",
    path: edit_45uploadCESgQSobpgMeta?.path ?? "/agent/my-refers/:refer_id()/management/transference/edit-upload",
    meta: edit_45uploadCESgQSobpgMeta || {},
    alias: edit_45uploadCESgQSobpgMeta?.alias || [],
    redirect: edit_45uploadCESgQSobpgMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/edit-upload.vue").then(m => m.default || m)
  },
  {
    name: indexiiZ81IV4TJMeta?.name ?? "agent-my-refers-refer_id-management-transference",
    path: indexiiZ81IV4TJMeta?.path ?? "/agent/my-refers/:refer_id()/management/transference",
    meta: indexiiZ81IV4TJMeta || {},
    alias: indexiiZ81IV4TJMeta?.alias || [],
    redirect: indexiiZ81IV4TJMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/index.vue").then(m => m.default || m)
  },
  {
    name: update5zAgt96SZeMeta?.name ?? "agent-my-refers-refer_id-management-transference-update",
    path: update5zAgt96SZeMeta?.path ?? "/agent/my-refers/:refer_id()/management/transference/update",
    meta: update5zAgt96SZeMeta || {},
    alias: update5zAgt96SZeMeta?.alias || [],
    redirect: update5zAgt96SZeMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/update.vue").then(m => m.default || m)
  },
  {
    name: uploaddMym0TQx82Meta?.name ?? "agent-my-refers-refer_id-management-transference-upload",
    path: uploaddMym0TQx82Meta?.path ?? "/agent/my-refers/:refer_id()/management/transference/upload",
    meta: uploaddMym0TQx82Meta || {},
    alias: uploaddMym0TQx82Meta?.alias || [],
    redirect: uploaddMym0TQx82Meta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/transference/upload.vue").then(m => m.default || m)
  },
  {
    name: indexR2oiAtKAJgMeta?.name ?? "agent-my-refers-refer_id-management-update-marketing",
    path: indexR2oiAtKAJgMeta?.path ?? "/agent/my-refers/:refer_id()/management/update-marketing",
    meta: indexR2oiAtKAJgMeta || {},
    alias: indexR2oiAtKAJgMeta?.alias || [],
    redirect: indexR2oiAtKAJgMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/update-marketing/index.vue").then(m => m.default || m)
  },
  {
    name: marketing_45offline_45dailymEalhjL1VKMeta?.name ?? "agent-my-refers-refer_id-management-update-marketing-marketing-offline-daily",
    path: marketing_45offline_45dailymEalhjL1VKMeta?.path ?? "/agent/my-refers/:refer_id()/management/update-marketing/marketing-offline-daily",
    meta: marketing_45offline_45dailymEalhjL1VKMeta || {},
    alias: marketing_45offline_45dailymEalhjL1VKMeta?.alias || [],
    redirect: marketing_45offline_45dailymEalhjL1VKMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/update-marketing/marketing-offline-daily.vue").then(m => m.default || m)
  },
  {
    name: marketing_45online_45dailyorx81cCaRDMeta?.name ?? "agent-my-refers-refer_id-management-update-marketing-marketing-online-daily",
    path: marketing_45online_45dailyorx81cCaRDMeta?.path ?? "/agent/my-refers/:refer_id()/management/update-marketing/marketing-online-daily",
    meta: marketing_45online_45dailyorx81cCaRDMeta || {},
    alias: marketing_45online_45dailyorx81cCaRDMeta?.alias || [],
    redirect: marketing_45online_45dailyorx81cCaRDMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/update-marketing/marketing-online-daily.vue").then(m => m.default || m)
  },
  {
    name: upload_45contractP1zry47gpKMeta?.name ?? "agent-my-refers-refer_id-management-upload-contract",
    path: upload_45contractP1zry47gpKMeta?.path ?? "/agent/my-refers/:refer_id()/management/upload-contract",
    meta: upload_45contractP1zry47gpKMeta || {},
    alias: upload_45contractP1zry47gpKMeta?.alias || [],
    redirect: upload_45contractP1zry47gpKMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/management/upload-contract.vue").then(m => m.default || m)
  },
  {
    name: reviewjyNhAuKz8UMeta?.name ?? "agent-my-refers-refer_id-review",
    path: reviewjyNhAuKz8UMeta?.path ?? "/agent/my-refers/:refer_id()/review",
    meta: reviewjyNhAuKz8UMeta || {},
    alias: reviewjyNhAuKz8UMeta?.alias || [],
    redirect: reviewjyNhAuKz8UMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/[refer_id]/review.vue").then(m => m.default || m)
  },
  {
    name: indexvQPAra3yGhMeta?.name ?? "agent-my-refers",
    path: indexvQPAra3yGhMeta?.path ?? "/agent/my-refers",
    meta: indexvQPAra3yGhMeta || {},
    alias: indexvQPAra3yGhMeta?.alias || [],
    redirect: indexvQPAra3yGhMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/my-refers/index.vue").then(m => m.default || m)
  },
  {
    name: _91refer_id_93q0joIgXAkYMeta?.name ?? "agent-refers-refer_id",
    path: _91refer_id_93q0joIgXAkYMeta?.path ?? "/agent/refers/:refer_id()",
    meta: _91refer_id_93q0joIgXAkYMeta || {},
    alias: _91refer_id_93q0joIgXAkYMeta?.alias || [],
    redirect: _91refer_id_93q0joIgXAkYMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/refers/[refer_id].vue").then(m => m.default || m)
  },
  {
    name: indexguqWiOI0TFMeta?.name ?? "agent-refers",
    path: indexguqWiOI0TFMeta?.path ?? "/agent/refers",
    meta: indexguqWiOI0TFMeta || {},
    alias: indexguqWiOI0TFMeta?.alias || [],
    redirect: indexguqWiOI0TFMeta?.redirect || undefined,
    component: () => import("/app/pages/agent/refers/index.vue").then(m => m.default || m)
  },
  {
    name: loginikXFF2hTKwMeta?.name ?? "auth-login",
    path: loginikXFF2hTKwMeta?.path ?? "/auth/login",
    meta: loginikXFF2hTKwMeta || {},
    alias: loginikXFF2hTKwMeta?.alias || [],
    redirect: loginikXFF2hTKwMeta?.redirect || undefined,
    component: () => import("/app/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: forget_45passwordEVWK44q6hlMeta?.name ?? "forget-password",
    path: forget_45passwordEVWK44q6hlMeta?.path ?? "/forget-password",
    meta: forget_45passwordEVWK44q6hlMeta || {},
    alias: forget_45passwordEVWK44q6hlMeta?.alias || [],
    redirect: forget_45passwordEVWK44q6hlMeta?.redirect || undefined,
    component: () => import("/app/pages/forget-password.vue").then(m => m.default || m)
  },
  {
    name: healthzgi5jXRlOnQMeta?.name ?? "healthz",
    path: healthzgi5jXRlOnQMeta?.path ?? "/healthz",
    meta: healthzgi5jXRlOnQMeta || {},
    alias: healthzgi5jXRlOnQMeta?.alias || [],
    redirect: healthzgi5jXRlOnQMeta?.redirect || undefined,
    component: () => import("/app/pages/healthz.vue").then(m => m.default || m)
  },
  {
    name: indexN6pT4Un8hYMeta?.name ?? "index",
    path: indexN6pT4Un8hYMeta?.path ?? "/",
    meta: indexN6pT4Un8hYMeta || {},
    alias: indexN6pT4Un8hYMeta?.alias || [],
    redirect: indexN6pT4Un8hYMeta?.redirect || undefined,
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: listing_45insight_45backupxMNucnPezbMeta?.name ?? "listing-insight-backup",
    path: listing_45insight_45backupxMNucnPezbMeta?.path ?? "/listing-insight-backup",
    meta: listing_45insight_45backupxMNucnPezbMeta || {},
    alias: listing_45insight_45backupxMNucnPezbMeta?.alias || [],
    redirect: listing_45insight_45backupxMNucnPezbMeta?.redirect || undefined,
    component: () => import("/app/pages/listing-insight-backup.vue").then(m => m.default || m)
  },
  {
    name: listing_45insightXejzTz1ENLMeta?.name ?? "listing-insight",
    path: listing_45insightXejzTz1ENLMeta?.path ?? "/listing-insight",
    meta: listing_45insightXejzTz1ENLMeta || {},
    alias: listing_45insightXejzTz1ENLMeta?.alias || [],
    redirect: listing_45insightXejzTz1ENLMeta?.redirect || undefined,
    component: () => import("/app/pages/listing-insight.vue").then(m => m.default || m)
  },
  {
    name: nayoo_45callbacksr2mrYCOi3Meta?.name ?? "nayoo-callback",
    path: nayoo_45callbacksr2mrYCOi3Meta?.path ?? "/nayoo-callback",
    meta: nayoo_45callbacksr2mrYCOi3Meta || {},
    alias: nayoo_45callbacksr2mrYCOi3Meta?.alias || [],
    redirect: nayoo_45callbacksr2mrYCOi3Meta?.redirect || undefined,
    component: () => import("/app/pages/nayoo-callback.vue").then(m => m.default || m)
  },
  {
    name: indexGkDmAZq53wMeta?.name ?? "property-comparison",
    path: indexGkDmAZq53wMeta?.path ?? "/property-comparison",
    meta: indexGkDmAZq53wMeta || {},
    alias: indexGkDmAZq53wMeta?.alias || [],
    redirect: indexGkDmAZq53wMeta?.redirect || undefined,
    component: () => import("/app/pages/property-comparison/index.vue").then(m => m.default || m)
  },
  {
    name: insightIKNKOwCMfdMeta?.name ?? "property-comparison-insight",
    path: insightIKNKOwCMfdMeta?.path ?? "/property-comparison/insight",
    meta: insightIKNKOwCMfdMeta || {},
    alias: insightIKNKOwCMfdMeta?.alias || [],
    redirect: insightIKNKOwCMfdMeta?.redirect || undefined,
    component: () => import("/app/pages/property-comparison/insight.vue").then(m => m.default || m)
  },
  {
    name: resultsQg7MNNza8Meta?.name ?? "property-comparison-result",
    path: resultsQg7MNNza8Meta?.path ?? "/property-comparison/result",
    meta: resultsQg7MNNza8Meta || {},
    alias: resultsQg7MNNza8Meta?.alias || [],
    redirect: resultsQg7MNNza8Meta?.redirect || undefined,
    component: () => import("/app/pages/property-comparison/result.vue").then(m => m.default || m)
  },
  {
    name: property_45owner_45callbackRuNEbQxaVwMeta?.name ?? "property-owner-callback",
    path: property_45owner_45callbackRuNEbQxaVwMeta?.path ?? "/property-owner-callback",
    meta: property_45owner_45callbackRuNEbQxaVwMeta || {},
    alias: property_45owner_45callbackRuNEbQxaVwMeta?.alias || [],
    redirect: property_45owner_45callbackRuNEbQxaVwMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner-callback.vue").then(m => m.default || m)
  },
  {
    name: indexslGKw28EnlMeta?.name ?? "property-owner",
    path: indexslGKw28EnlMeta?.path ?? "/property-owner",
    meta: indexslGKw28EnlMeta || {},
    alias: indexslGKw28EnlMeta?.alias || [],
    redirect: indexslGKw28EnlMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/index.vue").then(m => m.default || m)
  },
  {
    name: _91ordinal_93vvQiwsppcqMeta?.name ?? "property-owner-refer-refer_id-report-marketing-ordinal",
    path: _91ordinal_93vvQiwsppcqMeta?.path ?? "/property-owner/refer/:refer_id()/report-marketing/:ordinal()",
    meta: _91ordinal_93vvQiwsppcqMeta || {},
    alias: _91ordinal_93vvQiwsppcqMeta?.alias || [],
    redirect: _91ordinal_93vvQiwsppcqMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/report-marketing/[ordinal].vue").then(m => m.default || m)
  },
  {
    name: indexzQOQlsRptWMeta?.name ?? "property-owner-refer-refer_id-report-marketing",
    path: indexzQOQlsRptWMeta?.path ?? "/property-owner/refer/:refer_id()/report-marketing",
    meta: indexzQOQlsRptWMeta || {},
    alias: indexzQOQlsRptWMeta?.alias || [],
    redirect: indexzQOQlsRptWMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/report-marketing/index.vue").then(m => m.default || m)
  },
  {
    name: reviewtHpNp9vYxXMeta?.name ?? "property-owner-refer-refer_id-review",
    path: reviewtHpNp9vYxXMeta?.path ?? "/property-owner/refer/:refer_id()/review",
    meta: reviewtHpNp9vYxXMeta || {},
    alias: reviewtHpNp9vYxXMeta?.alias || [],
    redirect: reviewtHpNp9vYxXMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/review.vue").then(m => m.default || m)
  },
  {
    name: indexWbETje4xSYMeta?.name ?? "property-owner-refer-refer_id-sale-agreement",
    path: indexWbETje4xSYMeta?.path ?? "/property-owner/refer/:refer_id()/sale-agreement",
    meta: indexWbETje4xSYMeta || {},
    alias: indexWbETje4xSYMeta?.alias || [],
    redirect: indexWbETje4xSYMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/sale-agreement/index.vue").then(m => m.default || m)
  },
  {
    name: indexGhND8d1eWeMeta?.name ?? "property-owner-refer-refer_id-sale-report-interest",
    path: indexGhND8d1eWeMeta?.path ?? "/property-owner/refer/:refer_id()/sale-report/interest",
    meta: indexGhND8d1eWeMeta || {},
    alias: indexGhND8d1eWeMeta?.alias || [],
    redirect: indexGhND8d1eWeMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/sale-report/interest/index.vue").then(m => m.default || m)
  },
  {
    name: index7FfcpiSYPjMeta?.name ?? "property-owner-refer-refer_id-sale-report-monthly",
    path: index7FfcpiSYPjMeta?.path ?? "/property-owner/refer/:refer_id()/sale-report/monthly",
    meta: index7FfcpiSYPjMeta || {},
    alias: index7FfcpiSYPjMeta?.alias || [],
    redirect: index7FfcpiSYPjMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/sale-report/monthly/index.vue").then(m => m.default || m)
  },
  {
    name: indexlG5i6bQg10Meta?.name ?? "property-owner-refer-refer_id-sale-report-visit",
    path: indexlG5i6bQg10Meta?.path ?? "/property-owner/refer/:refer_id()/sale-report/visit",
    meta: indexlG5i6bQg10Meta || {},
    alias: indexlG5i6bQg10Meta?.alias || [],
    redirect: indexlG5i6bQg10Meta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/sale-report/visit/index.vue").then(m => m.default || m)
  },
  {
    name: show_45confirmLJxnmxy7VfMeta?.name ?? "property-owner-refer-refer_id-show-confirm",
    path: show_45confirmLJxnmxy7VfMeta?.path ?? "/property-owner/refer/:refer_id()/show-confirm",
    meta: show_45confirmLJxnmxy7VfMeta || {},
    alias: show_45confirmLJxnmxy7VfMeta?.alias || [],
    redirect: show_45confirmLJxnmxy7VfMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/show-confirm.vue").then(m => m.default || m)
  },
  {
    name: show_45have_45agentpAjsHXz70TMeta?.name ?? "property-owner-refer-refer_id-show-have-agent",
    path: show_45have_45agentpAjsHXz70TMeta?.path ?? "/property-owner/refer/:refer_id()/show-have-agent",
    meta: show_45have_45agentpAjsHXz70TMeta || {},
    alias: show_45have_45agentpAjsHXz70TMeta?.alias || [],
    redirect: show_45have_45agentpAjsHXz70TMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/show-have-agent.vue").then(m => m.default || m)
  },
  {
    name: indexcTyFldMbfbMeta?.name ?? "property-owner-refer-refer_id-transference",
    path: indexcTyFldMbfbMeta?.path ?? "/property-owner/refer/:refer_id()/transference",
    meta: indexcTyFldMbfbMeta || {},
    alias: indexcTyFldMbfbMeta?.alias || [],
    redirect: indexcTyFldMbfbMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/refer/[refer_id]/transference/index.vue").then(m => m.default || m)
  },
  {
    name: registerAnpuNsk5IFMeta?.name ?? "property-owner-register",
    path: registerAnpuNsk5IFMeta?.path ?? "/property-owner/register",
    meta: registerAnpuNsk5IFMeta || {},
    alias: registerAnpuNsk5IFMeta?.alias || [],
    redirect: registerAnpuNsk5IFMeta?.redirect || undefined,
    component: () => import("/app/pages/property-owner/register.vue").then(m => m.default || m)
  },
  {
    name: social_45callbackcznafy6RZnMeta?.name ?? "social-callback",
    path: social_45callbackcznafy6RZnMeta?.path ?? "/social-callback",
    meta: social_45callbackcznafy6RZnMeta || {},
    alias: social_45callbackcznafy6RZnMeta?.alias || [],
    redirect: social_45callbackcznafy6RZnMeta?.redirect || undefined,
    component: () => import("/app/pages/social-callback.vue").then(m => m.default || m)
  }
]